import api from './axios';

export const listUsuarios = (idEmpresa) => api.get('/usuarios/', { params: { id_empresa: idEmpresa } });
export const createUsuario = (data) => api.post('/usuarios/', data);
export const updateUsuario = (id, data) => api.patch(`/usuarios/${id}`, data);
